import Breadcrumb  from "../components/Breadcrumb";
import HoursCard   from "../components/HoursCard";

const STORE_HOURS = [
  { day: "Monday – Friday", time: "7:00 am – 11:00 pm" },
  { day: "Saturday",        time: "7:00 am – 11:00 pm"  },
  { day: "Sunday",          time: "8:00 am – 11:00 pm"  },
];

const CONTACT_INFO = [
  {
    icon: "📍", label: "Address",
    value: (
      <a
        href="https://www.google.com/maps/place/London,+ON/data=!4m2!3m1!1s0x882ef20ea88d9b0b:0x28c7d7699a056b95?sa=X&ved=1t:242&ictx=111"
        target="_blank"
        rel="noreferrer"
      >
        London ON
      </a>
    ),
  },
  {
    icon: "📞", label: "Phone",
    value: <a href="tel:##-###-####">##-###-####</a>,
  },
  {
    icon: "✉️", label: "Email",
    value: <a href="mailto:privateconvenience@gmail.com">privateconvenience@gmail.com</a>,
  },
];

const SOCIAL_LINKS = [
  { label: "fb", href: "https://www.facebook.com/privateconvenience" },
  { label: "ig", href: "https://www.instagram.com/private_convenience/" },
  { label: "tw", href: "https://twitter.com/PrivateConvenience" },
];

const PILLS = [
  "Family Owned", "Est. 2014", "London, Ontario",
  "American Imports", "Rare Snacks", "Fireworks", "7 Days a Week",
];

export default function AboutPage() {
  const crumbs = [
    { label: "Home", page: "home" },
    { label: "About Us" },
  ];

  return (
    <div className="page-wrap fade-up">
      <Breadcrumb crumbs={crumbs} />

      <div className="about-layout">

        {/* ── Left: Story ── */}
        <div className="about-text">
          <h2>A Family Store.<br />A London Staple.</h2>
          <p>
            Private Convenience is a locally run family store operating under
            new management since 2014. For over a decade, we've been proudly
            serving the London, Ontario community with a unique selection of products, friendly service, and a commitment to quality.
          </p>
          <p>
            Our variety store offers some of the most versatile and unique
            products available in the city. From numerous flavors of American
            drinks to all kinds of unique snacks — there is truly something for
            everyone.
          </p>
          <p>
            We're constantly refreshing our stock with new and exciting items,
            seasonal specials, and hard-to-find imports. Come in and discover
            what's new.
          </p>
          <p>
            Come visit us at{" "}
            <a
              href="https://www.google.com/maps/place/London,+ON/data=!4m2!3m1!1s0x882ef20ea88d9b0b:0x28c7d7699a056b95?sa=X&ved=1t:242&ictx=111"
              target="_blank"
              rel="noreferrer"
            >
              London, Ontario
            </a>
            .
          </p>

          <div className="about-pills">
            {PILLS.map((pill) => (
              <span key={pill} className="about-pill">{pill}</span>
            ))}
          </div>
        </div>

        {/* ── Right: Hours + Contact ── */}
        <div>
          <HoursCard
            icon="🕐"
            title="Store Hours"
            rows={STORE_HOURS}
            note="⚠️ Hours subject to change during holidays."
          />

          <div className="contact-strip" style={{ marginTop: 18 }}>
            <h3>Get In Touch</h3>
            {CONTACT_INFO.map(({ icon, label, value }) => (
              <div key={label} className="cinfo-row">
                <span className="cinfo-icon">{icon}</span>
                <div>
                  <div className="cinfo-label">{label}</div>
                  <div className="cinfo-val">{value}</div>
                </div>
              </div>
            ))}

            <div className="social-row">
              {SOCIAL_LINKS.map(({ label, href }) => (
                <a key={label} href={href} target="_blank" rel="noreferrer" className="social-btn">
                  {label}
                </a>
              ))}
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}
